export const endpoints = {
  account: {
    updateAccount: '/Account', // PATCH
    signUp: '/Account/sign-up', // POST
    invitedSignUp: '/Account/confirm-invitation', // POST
    setPIN: '/Account/updatepin', // POST
    updatePIN: '/Account', // PUT
    userHasPIN: '/Account/has-pin-set'
  },
  email: {
    welcome: '/Email/welcome-email', // POST
  },
  auth: {
    login: '/Auth/sign-in', // POST
    resetPassword: '/Auth/forgot-password', // POST
    confirmResetPassword: '/Auth/confirm-forgot-password', // POST
    validateInvitation: '/Auth/validate-invite', // POST
    validatePasswordLink: '/Auth/validate-password-link',
    logout: '/Auth/sign-out', // POST
  },
  npi: {
    getNPI: '/NPI/', // +{npiNumber}; GET
  },
  drug: {
    search: '/drug', // POST
    getAll: '/drug', // GET
    getAllFromInventory: '/drug/in-inventory', // GET
    getDosageUnits: '/drug/dosage-units', // GET
    getDosageForms: '/drug/dosage-forms', // GET
    createDosageUnit: '/drug/dosage-unit', // PUT
    createDosageForm: '/drug/dosage-form', // PUT
    createCompound: '/drug/compound', // PUT
    getCompounds: '/drug/compounds', //GET
    isCompoundNdcInvalid: '/drug/compound-ndc-invalid/', //GET + NDC
  },
  inventory: {
    search: '/Transaction/inventory/search',
    getAll: '/Transaction/inventory/all',
    setStatus: '/Transaction/set-drug-status', // POST ?active=true
    getInventoryByDrugID: '/Transaction/inventory/', // +{pharmacyID}?drug=${drugID}; GET,
    loadInventoryFromLibertyRx: '/Transaction/inventory/load-from-LibertyRx', // GET
    getInventoriesOnHandValues: '/Transaction/inventories', // POST
    getInventoryOnHandForMoment: '/Transaction/inventory-for-moment', // POST
    isInventoryModifiedToday: '/Transaction/inventory/is-modified-today', // GET
    getInventoryTransactions: '/Transaction/inventory/search/', //?drug=${drugID}; GET,
    move: '/Transaction/inventory/move/', //POST
    bulkGetSimilar: '/Transaction/inventory/similar/' //GET  + array of gpis
  },
  pharmacy: {
    getPharmaciesByUserId: '/Pharmacy/get-pharmacies-by-user/', // +{userId}; GET
    getUsersByPharmacyId: '/Pharmacy/get-users-by-pharmacy/', // +{id}/{status?}; GET
    // valid
    getAllPharmacies: '/Pharmacy', // GET
    getPharmacy: '/Pharmacy/', // +{id}; GET
    createPharmacy: '/Pharmacy', // PUT
    updatePharmacy: '/Pharmacy', // PATCH
    // TODO: needs implementation
    addPharmacyUser: '/PharmaciesUsers', // PUT
    removePharmacyUser: '/PharmaciesUsers', // DELETE
    getDashboardData: '/Pharmacy/account-settings-container'
  },
  report: {
    dea: {
      getReport: '/Report/dea/history', // +{id}; GET
      downloadCsv: '/Report/dea/download/csv', // +{id}; GET
      downloadPdf: '/Report/dea/download/pdf', // +{id}; GET
      sign: '/Report/dea/Sign', // POST
      runReport: '/Report/dea', // PUT
      saveDetail: '/Report/dea/detail' // POST
    },
    getReportRecords: '/Report', // GET
    custom: {
      runReport: '/Report/Custom', // POST
      downloadCsv: '/report/download-custom-report/csv', // POST
      downloadPdf: '/report/download-custom-report/pdf', // POST
    },
    inventoryTotals: {
      runReport: '/Report/inventory-totals', // POST
      downloadCsv: '/report/inventory-totals/generate/csv', // POST
      downloadPdf: '/report/inventory-totals/generate/pdf' //POST
    },
    ndcPurchase: {
      runReport: '/Report/ndc-purchase', // POST
      downloadPdf: '/Report/ndc-purchase/generate/pdf',
      downloadCsv: '/Report/ndc-purchase/generate/csv'
    },
    currentInventory: {
      runReport: '/Report/current-on-hand', // GET
      exportPdf: '/Report/current-on-hand/export/pdf',// POST
      exportCsv: '/Report/current-on-hand/export/csv',// POST
    },
    soh: {
      runReport: '/Report/similar-on-hand-history', // POST
      downloadPdf: '/Report/similar-on-hand-history/generate/pdf',
      downloadCsv: '/Report/similar-on-hand-history/generate/csv'
    }

  },
  sign: {
    signWithPIN: '/Sign', // POST
  },
  transaction: {
    getDashboardSummary: '/Transaction', // POST
    createTransaction: '/Transaction', // PUT
    getAllTransactions: '/Transaction/get-all/', // +{pharmacyID}; GET
    getTransaction: '/Transaction/get/', // +{id}; GET
    searchWithDetails: '/Transaction/search-with-details/', // + searchCriteria
    searchWithoutDetails: '/Transaction/search',
    getAmendReasons: '/Transaction/amend-reasons',
    createAmendment: '/Transaction/amend', // PUT
    validateTransactionDateForInventories: '/Transaction/inventories/validate-transaction-date', //POST
    ValidateTransactionDateForAmend: '/Transaction/inventories/validate-transaction-date-in-amend', //POST
    ValidateTransactionDateForCompoundAmendIngredients: '/Transaction/inventories/validate-transaction-date-in-compound-amend', //POST
    updateTransactionDate: '/Transaction/inventories/update-transactionDate', //POST
    getTransactionDateChangeHistory:  '/Transaction/transaction-date-change-history/', //+{transactionId} GET
    getMostRecentAuditTransactionDate:  '/Transaction/most-recent-audit-date/', //+{drugId}/{locationId} GET
    testForDupTransactions: '/Transaction/dupes', //POST
    getCompounds: '/Transaction/compounds', //GET
    receiveCompound: '/Transaction/compound', // POST
    getCompound: '/Transaction/compound', // GET + {id}
    getAmendIngredientsWaste: '/Transaction/compound/amend-ingredients-waste', // GET + {id}
    amendCompound: '/Transaction/compound/amend', // POST
    ingredientsFromTheLatestCompounding: '/Transaction/compound/latest-ingredients', // GET + {drugID}

  },
  integration: {
    getAll: '/Integration',  // +{pharmacyId}GET
    getAllPendingTransactions: '/Integration/pending-transactions', // +{pharmacyID}; GET
    getBulkVerifyPendingTransactions: '/Integration/bulk-verify-pending-transactions', //GET
    bulkVerifyValidateTrDate: '/Integration/bulk-verify-pending-transactions/validate-transaction-date', //POST
    bulkVerify: '/Integration/bulk-verify-pending-transactions', //PATCH
    isBulkVerifyInProgress: '/Integration/bulk-verify-pending-transactions/is-in-progress', //GET
    getPendingTransaction: '/Integration/pending-transaction', // +{pharmacyID}; GET
    refreshPendingTransactionDetails: '/Integration/pending-transaction-latest', // +{pharmacyID}; GET
    confirmTansaction: '/Integration', // PATCH
    confirmSplitNdcsDispense: '/Integration/split-ndcs', // PATCH
    confirmSplitNdcsAmendment: '/Integration/split-ndcs-amend', // PATCH
    confirmTheCombinedOwedAndSplitDispense: '/Integration/combined-owed-split', //PATCH
    liberty: {
      addEdit: '/Integration/liberty/config', // POST
      testConnection: '/Integration/liberty/test', // POST
      cancelLoadInventoryFromLibertyRx: '/Integration/liberty/cancel-inventory-load', // GET
      getLibertyRxLoadStatus: '/Integration/get-libertyRx-page-load-status', // GET
      getLibertyRxPageInventory: '/Integration/get-libertyRx-page-inventory', // GET
      postLibertyRxLoadAcknowledged: '/Integration/set-libertyRx-load-acknowledged', // GET
      updateLibertyRxPageInventory: '/Integration/update-libertyRx-page-inventory', // POST
      removeLibertyRxPageInventory: '/Integration/remove-libertyRx-page-inventory', // POST
      clearLibertyRxPageInventory: '/Integration/clear-libertyRx-page-inventory', // POST
      isConfigurationOn: '/Integration/libertyRx/integration/on' //GET
    },
    pioneerRx: {
      createIntegration: '/Integration/PioneerRx/config/create' //PUT
    },
    frameworkLTC: {
      createIntegration: '/Integration/FrameworkLTC/config/create' //PUT
    },
    invalidateTransaction: '/Integration/invalidate-transaction/', // PATCH
    validateTransactionDateForPendingTransactionAmend: '/Integration/pending-transaction/amend/validate-transaction-date', //POST
    markPendingTransactionAsConfirmed: '/Integration/mark-as-confirmed', //POST
    getUnconfirmedPendingDispenseOwedQuantity: '/Integration/owed/', //GET +{rxNumber}/{refillNumber}
    toggle: '/Integration/toggle' //POST
  },
  user: {
    getUser: '/User', // GET
    createUser: '/User', // PUT
    updateUser: '/User', // PATCH
    resendInvitation: '/User/resend-invite', // PUT
    revokeInvite: '/User/revoke-invite/', // +{email} GET
    getBeaconSignature: '/User/beacon-signature', // GET
    validateCredentials: '/User/validate'
  },
  wholesalerIntegration: {
    getSingle: '/WholesalerIntegration', // +{id}GET
    create: '/WholesalerIntegration', // PUT
    edit: '/WholesalerIntegration', // PATCH
    delete: '/WholesalerIntegration', // DELETE
    getAll: '/WholesalerIntegration/all-for-current-pharmacy',  // +{id}GET
    getAllWholesalers: '/WholesalerIntegration/wholesalers', // GET
    createWholesaler: '/WholesalerIntegration/wholesalers', // PUT
    removeWholesaler: '/WholesalerIntegration/wholesalers', // DELETE
    testConnection: '/WholesalerIntegration/test-ftp-connection',
    updateActivity: '/WholesalerIntegration/update-activity',
    runParsing: '/WholesalerIntegration/run' // POST
  },
  order: {
    getOrder: '/Order',
    receiveOrder: '/Order/receive-order',
    orderList: '/Order',
    updateOrder: '/Order', // PATCH
    totalProcessed: '/Order/total-processed',
    processAttachment: '/Order/attachment', // PATCH
    getAttachment: '/Order/attachment', // POST
    updateUploadedAttachment: '/Order/attachment/uploaded', // PATCH
    createProvider: '/Order/provider', //PUT
    getProviders: '/Order/provider', //GET
    saveNewSaleOrReturn: '/Order/sell-return', //PUT
    destroyInventory: '/Order/inventory-destruction', //PUT
    getSalesToProviders: '/Order/sales/providers', //GET
    getSaleToProviderDetails: '/Order/sales/providers/details', //GET
    createReverseDistributor: '/Order/reverse-distributor', //PUT
    createPlaceOfDestruction: '/Order/place-of-destruction', //PUT
    getReverseDistributors: '/Order/reverse-distributor', //GET
    getPlacesOfDestruction: '/Order/places-of-destruction', //GET
    getSalesToReverseDistributors: '/Order/sales/reverse-distributors', //GET
    getSaleToReverseDistributorDetails: '/Order/sales/reverse-distributors/details', //GET
    getReturnsToWholesalers: '/Order/returns/wholesalers', //GET
    getReturnToWholesalerDetails: '/Order/returns/wholesalers/details', //GET
    getInventoryDestructions: '/Order/inventory-destructions', //GET
    getInventoryDestructionDetails: '/Order/inventory-destruction/details', //GET
    getBuyersList: '/Order/buyers', //GET
    getEdiSuppliersList: '/Order/edi-suppliers', //GET
    createPartyWithDetail: '/Order/party/detail', //PUT
    getPartyDetails: '/Order/party/details', // + partyID
    getPartyLatestDetails: '/Order/party/latest-details/', // GET + TYPE
  },
  audit: {
    getAudits: '/audits', //GET
    createAudit: '/audits', //PUT
    getAuditWithDetails: '/audits', // +{id} GET
    printAudit: '/audits', // +{id} POST
    addNewDetail: '/audits/detail', // PUT
    removeDetail: '/audits/detail', // DELETE
    confirmAuditDetails: '/audits/detail', // PATCH
    completeAudit: '/audits', // PATCH
    validateDetails: '/audits/details/validate', // POST
    isUnconfirmedBackCountNdcExists:  '/audits/back-count/unconfirmed-ndc-exists', // GET + locationID, drugID
    bulkGetNdcsExistInUnconfirmedBackCount:  '/audits/back-count/bulk-unconfirmed-ndcs-in-audit',
    getBackCountsInProgressCount: '/audits/back-count/in-progress-total', // GET
    getFirstBackCountID: '/audits/back-count/first-id' // GET
  },
  error: '/Error',
  preference: {
    toggleC3C5: '/PharmacyPreference/toggle-c3-c5', //{settingID} POST
    getDrugsOfInterest: '/PharmacyPreference/drugs-of-interest/', // GET
    updateDrugsToTrack: '/PharmacyPreference/update-drugs-to-track', //PATCH
    toggleInventoryLocations: '/PharmacyPreference/toggle-inventory-locations', //POST
    toggleBackCount: '/PharmacyPreference/back-count/toggle', //POST
    updateBackCount: '/PharmacyPreference/back-count/update', //PATCH
    toggleCompounding: '/PharmacyPreference/compounding/toggle', //POST
  },
  inventoryLocation: {
    saveLocation: '/InventoryLocation', // POST
    getAll: '/InventoryLocation', // GET
    removeLocation: '/InventoryLocation/', //DELETE
    updateActivityStatus: '/InventoryLocation/', //PATCH
    inventoryOnLocation: '/InventoryLocation/inventory/', //{id}/{drugID}  GET
    bulkGetInventoryOnLocation: '/InventoryLocation/bulk-inventory'
  },
  clientState: {
    createOrUpdateBulkAddState: '/clientState/bulk-add-snapshot', //POST
    getBulkAddState: '/clientState/bulk-add-snapshot', //GET
    createOrUpdateAuditState: '/clientState/audit-details', //POST
    getAuditState: '/clientState/audit-details/', //GET + auditID
   },
   userMessage: {
    getUnreadMessagesSummary: '/message/summary', //GET + userID
    markMessageRead: '/message',
    getAllMessages: '/message',//GET + userID
    deleteUserMessage: '/message',//DELETE + userMessageId,
    getUnreadMessagesCount: '/message/unread-count',//GET + userMessageId
   }
};
